import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  showSuccess(message: string) {
    this.toastr.success(message, 'Éxito', {
      positionClass: 'toast-top-center' // Mostrar mensaje en la parte superior centro
    });
  }

  showError(message: string) {
    this.toastr.error(message, 'Error', {
      positionClass: 'toast-top-center' 
    });
  }

  showInfo(message: string) {
    this.toastr.info(message, 'Info', {
      positionClass: 'toast-top-center' 
    });
  }

  showWarning(message: string) {
    this.toastr.warning(message, 'Alerta', {
      positionClass: 'toast-top-center' 
    });
  }
  
}
